module.exports = __webpack_public_path__ + "img/logo_old.15ea07e4.png";